import { Loading } from "@components/common/Loading";
import { FormInstanceRenderer } from "@nomena-raminoheritiana/front-form-builder";
import { enqueueSnackbar } from "notistack";
import type { FC } from "react";
import { Box } from "@mui/material";
import { useLanguage } from "../../../../contexts/LanguageContext";

interface OfferFormProps {
    onSubmit?: (data: any) => Promise<void>;
    defaultValue?: any;
    formBuilderAccessToken: string | null;
    loading?: boolean;
    successMessage?: string;
}

const OfferForm: FC<OfferFormProps> = ({
    onSubmit,
    defaultValue,
    formBuilderAccessToken,
    successMessage,
    loading
}) => {

    const { language } = useLanguage(); 

    const handleAfterSubmit = async (data: any) => {
        if (onSubmit) {
            await onSubmit(data);
        }
        enqueueSnackbar(successMessage || 'Offer created successfully', { variant: 'success' });
    };

    return (
        <Box sx={{
            // Overrides globaux pour adapter les champs de texte et labels générés par le form-builder au thème sombre
            '& label': { color: '#8c94a4' },
            '& .MuiInputBase-root': { color: '#ffffff' },
            '& .MuiOutlinedInput-notchedOutline': { borderColor: '#1e2638' },
            '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#3a4459' },
        }}>
            {loading && <Loading />}
            {!loading && (
                <FormInstanceRenderer 
                    formInstanceId={`${import.meta.env.VITE_OFFER_FORM_INSTANCE_ID}`}
                    defaultValues={defaultValue}
                    showUnnamedFields={false}
                    accessToken={formBuilderAccessToken || undefined}
                    formLoader={() => <Loading />}
                    onSubmit={(data) => {
                        // Logique de soumission du formulaire
                        handleAfterSubmit(data);
                    }}
                    lang={language}
                />
            )}
        </Box>
    );
};

export default OfferForm;